import React, { useEffect, useState, useRef } from 'react';
import { PLACEHOLDER_EXPERIENCE, useAggregatorClient } from '../../aggregator-client-context';
import { withProductContext } from '../product-router';
import RegisterProduct from './register-product';
/**
 * A component which invokes the permissionSupplier, if supplied or uses the Search Platform's default permission checker.
 * The calls to the default API are batched.
 * In response it expects the permissible sections that should be shown to the user.
 */
export const CheckProductPermissions = ({
  children,
  permissionSupplier,
  id,
  title,
  sections,
  order,
  generateAdvancedSearchUrl,
  expandedStateInputPlaceholder,
  workspaces,
  autocorrectEnabled,
  showViewAllFiltersLink,
  tabRenderer,
  aiSearchConfig,
  showSearchOnEnter
}) => {
  const invokePostQuerySearchRef = useRef(() => {});
  const [allowedSections, setAllowedSections] = useState([]);
  const searchClient = useAggregatorClient();
  useEffect(() => {
    if (allowedSections.length === 0) {
      const promise = permissionSupplier ? permissionSupplier() : searchClient ? searchClient.batchedGetExtensibleProductPermission(id, {
        productIds: [id],
        experience: PLACEHOLDER_EXPERIENCE
      }) : Promise.resolve([]);
      promise.then(response => {
        setAllowedSections(response);
      });
    }
    /**
     * We want to replicate componentDidMount behaviour to avoid invoking the API multiple times and we don't care if any other deps changed.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return allowedSections.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RegisterProduct, {
    allowedSections: allowedSections,
    sections: sections,
    id: id,
    title: title,
    order: order,
    generateAdvancedSearchUrl: generateAdvancedSearchUrl,
    expandedStateInputPlaceholder: expandedStateInputPlaceholder,
    workspaces: workspaces,
    autocorrectEnabled: autocorrectEnabled,
    showViewAllFiltersLink: showViewAllFiltersLink,
    tabRenderer: tabRenderer,
    aiSearchConfig: aiSearchConfig,
    showSearchOnEnter: showSearchOnEnter,
    invokePostQuerySearchRef: invokePostQuerySearchRef
  }, children)) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default withProductContext(CheckProductPermissions);